import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineFileSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    viewBox="0 0 44 44"
    {...props}
  >
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M36.5 15.993a15.4 15.4 0 0 0-6.5-1.43c-8.526 0-15.438 6.91-15.438 15.437 0 5.458 2.833 10.254 7.109 13H4a3.25 3.25 0 0 1-3.25-3.25V4A3.25 3.25 0 0 1 4 .75h21.125l11.374 11.375z"
      clipRule="evenodd"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M36.5 13.75v-1.625L25.124.75H4A3.25 3.25 0 0 0 .75 4v35.75A3.25 3.25 0 0 0 4 43h16.25"
    />
    <path
      fill="#fff"
      d="M30 39.75c5.385 0 9.75-4.366 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M30 39.75c5.385 0 9.75-4.366 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75M43 43l-6.106-6.106"
    />
  </svg>
);
export default SvgStreamlineFileSearch;
